(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};

  window.SPCLST.modules.nav = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;
    var on = helpers.on;
    var parseBool = helpers.parseBool;
    var isMobileViewport = helpers.isMobileViewport;
    var isDesktopNavViewport = helpers.isDesktopNavViewport;

    var body = document.body;
    var mobileNav = query('.opened-mobile-nav');
    var mobileSearch = query('.opened-mobile-search');
    var headerCandidates = queryAll('[data-spclst-header]');
    var headerRoot =
      headerCandidates.find(function (candidate) {
        return !!(candidate && candidate.offsetParent !== null);
      }) ||
      headerCandidates[0] ||
      query('.navbar.spclst-nav-home');
    var desktopNav = query('.desktop-nav');
    var headerMobileNav = query('.navbar.spclst-nav-home .mobile-nav');
    var desktopNavRow = query('[data-spclst-desktop-nav-row]');
    var homeHero = query('.spclst-hero');
    var mainContentRoot = query('#MainContent') || query('main');
    var submenuContainer = query('[data-spclst-submenu-container]');
    var desktopSubmenus = queryAll('[data-spclst-submenu]', submenuContainer || document);
    var desktopBrandTrigger = query(
      '[data-spclst-open-desktop-brand]',
      headerRoot || document
    );
    var desktopBrandSubmenu = query(
      '[data-spclst-submenu="brand"]',
      submenuContainer || document
    );
    var desktopSubmenuTriggers = queryAll(
      '[data-spclst-open-desktop-shop], [data-spclst-open-desktop-brand], [data-spclst-open-desktop-search]'
    );
    var heroPresentAtInit = !!query('[data-spclst-hero-section]');
    var transparentNavEnabled = !!heroPresentAtInit;
    var scrollAwayNavEnabled = true;
    var hasDynamicNavMode = !!headerRoot;
    var isDesignMode =
      document.documentElement.classList.contains('shopify-design-mode') ||
      !!(window.Shopify && window.Shopify.designMode);
    var navTopSection = null;
    var trackedScrollTarget = null;
    var lastScrollY = 0;
    var scrollDirection = 0;
    var directionStartY = 0;
    var navHidden = false;
    var scrollTicking = false;
    var hoverCloseTimer = null;
    var cartDrawer = query('cart-drawer');
    var cartBubble = query('#cart-icon-bubble');
    var mobileCartCounts = queryAll('.mobilecartcount');
    var mobileBrandSections = queryAll('.mobilemenusection');
    var freeShippingThresholdCents = 19900;
    var freeShippingSyncQueued = false;
    var headerSectionRoots = [];
    var mobileNavSuppressOpenUntil = 0;
    var mobileNavCloseTimer = null;

    function resolveHeaderSectionRoots() {
      headerSectionRoots = [];
      if (!headerRoot) return;

      var walker = headerRoot;
      while (walker) {
        var classList = walker.classList;
        if (
          classList &&
          (classList.contains('shopify-section-group-header-group') || classList.contains('section-header'))
        ) {
          if (headerSectionRoots.indexOf(walker) === -1) {
            headerSectionRoots.push(walker);
          }
        }
        walker = walker.parentElement;
      }

      [
        headerRoot.closest('.shopify-section-group-header-group'),
        headerRoot.closest('.section-header'),
      ].forEach(function (candidate) {
        if (!candidate) return;
        if (headerSectionRoots.indexOf(candidate) !== -1) return;
        headerSectionRoots.push(candidate);
      });

      if (!headerSectionRoots.length) {
        var genericSectionRoot = headerRoot.closest('[id^="shopify-section-"]');
        if (genericSectionRoot) {
          headerSectionRoots.push(genericSectionRoot);
        }
      }
    }

    resolveHeaderSectionRoots();

    function hasSpclstHeroSection() {
      return !!query('[data-spclst-hero-section]');
    }

    function refreshNavFeatureFlags() {
      if (!headerRoot) return;
      var heroPresent = hasSpclstHeroSection();

      /* Always use hero presence as the transparent trigger and keep scroll-away on
         for all non-hero states. This avoids per-page toggle/state drift in editor. */
      transparentNavEnabled = heroPresent;
      scrollAwayNavEnabled = true;
      hasDynamicNavMode = true;
    }

    function getWindowScrollY() {
      var scrollingElement = document.scrollingElement || document.documentElement;
      var rawY = window.pageYOffset;
      if (typeof rawY !== 'number') rawY = window.scrollY;
      if (typeof rawY !== 'number') rawY = scrollingElement ? scrollingElement.scrollTop : 0;
      var maxY = scrollingElement ? Math.max(0, scrollingElement.scrollHeight - scrollingElement.clientHeight) : rawY;
      return Math.max(0, Math.min(rawY || 0, maxY));
    }

    function getElementScrollY(element) {
      if (!element || typeof element.scrollTop !== 'number') return 0;
      return Math.max(0, Math.min(element.scrollTop, Math.max(0, element.scrollHeight - element.clientHeight)));
    }

    function getPrimaryScrollTarget() {
      if (mainContentRoot) {
        var mainCanScroll = mainContentRoot.scrollHeight - mainContentRoot.clientHeight > 2;
        if (mainCanScroll) {
          var mainOverflowY = window.getComputedStyle(mainContentRoot).overflowY;
          if (/(auto|scroll|overlay)/.test(mainOverflowY)) {
            return mainContentRoot;
          }
        }
      }

      return window;
    }

    function getScrollY() {
      var primary = getPrimaryScrollTarget();
      if (primary === window || primary === document) {
        return getWindowScrollY();
      }
      return getElementScrollY(primary);
    }

    function resolveTopSection() {
      refreshNavFeatureFlags();
      if (!hasDynamicNavMode) return;

      var transparentContextActive = transparentNavEnabled && hasSpclstHeroSection();
      if (transparentContextActive) {
        navTopSection = query('[data-spclst-hero-section]') || query('.spclst-hero');
      } else {
        navTopSection = null;
      }
    }

    function refreshTopSectionBounds() {}

    function hasOpenNavLayer() {
      var hasOpenDesktopSubmenu = submenuContainer && submenuContainer.classList.contains('spclst-open');
      var hasOpenMobileNav = mobileNav && mobileNav.classList.contains('spclst-open');
      var hasOpenMobileSearch = mobileSearch && mobileSearch.classList.contains('spclst-open');
      return hasOpenDesktopSubmenu || hasOpenMobileNav || hasOpenMobileSearch;
    }

    function applyNavMode(fromScroll) {
      refreshNavFeatureFlags();
      if (!hasDynamicNavMode || !headerRoot) return;

      var transparentContextActive = transparentNavEnabled && hasSpclstHeroSection();
      var scrollTarget = getPrimaryScrollTarget();
      var currentY = getScrollY();
      if (scrollTarget !== trackedScrollTarget) {
        trackedScrollTarget = scrollTarget;
        lastScrollY = currentY;
        directionStartY = currentY;
        scrollDirection = 0;
        navHidden = false;
      }
      var navHeight = headerRoot.offsetHeight || 0;
      var inTopSection = false;
      var forceTransparentTop = false;

      if (transparentContextActive) {
        if (!navTopSection) {
          resolveTopSection();
        }
        if (navTopSection) {
          var heroRect = navTopSection.getBoundingClientRect();
          inTopSection = heroRect.top < navHeight && heroRect.bottom > navHeight + 1;
        }
        forceTransparentTop = currentY <= 4;
      }

      headerRoot.classList.toggle('spclst-nav-force-transparent', forceTransparentTop);
      headerRoot.classList.toggle('spclst-nav-in-hero', inTopSection);
      headerRoot.classList.toggle('spclst-nav-below-hero', !!transparentContextActive && !inTopSection);
      headerRoot.classList.toggle('spclst-nav-mode-hero', !!transparentContextActive && inTopSection);
      headerRoot.classList.toggle('spclst-nav-mode-solid', !(!!transparentContextActive && inTopSection));

      var hasOpenLayer = hasOpenNavLayer();
      if (inTopSection || !scrollAwayNavEnabled || currentY <= navHeight + 8) {
        navHidden = false;
        scrollDirection = 0;
        directionStartY = currentY;
      } else if (!hasOpenLayer) {
        var delta = currentY - lastScrollY;
        if (!fromScroll && Math.abs(delta) >= 0.5) {
          scrollDirection = 0;
          directionStartY = currentY;
        } else if (fromScroll && Math.abs(delta) >= 0.5) {
          var nextDirection = delta > 0 ? 1 : -1;
          if (nextDirection !== scrollDirection) {
            scrollDirection = nextDirection;
            directionStartY = lastScrollY;
          }
          var mobileViewport = window.matchMedia('(max-width: 991px)').matches;
          var hideDistance = mobileViewport ? 6 : 2;
          var revealDistance = mobileViewport ? 14 : 8;
          if (nextDirection > 0 && currentY - directionStartY >= hideDistance) {
            navHidden = true;
          } else if (nextDirection < 0 && directionStartY - currentY >= revealDistance) {
            navHidden = false;
          }
        }
      }
      var shouldHide = navHidden && !hasOpenLayer && !inTopSection;

      headerRoot.classList.toggle('spclst-nav-hidden', shouldHide);

      var transparentNow =
        !!transparentContextActive &&
        !!(inTopSection || forceTransparentTop) &&
        !headerRoot.classList.contains('spclst-nav-hover') &&
        !headerRoot.classList.contains('spclst-nav-hidden');

      headerRoot.classList.toggle('spclst-nav-transparent-active', transparentNow);
      if (body) {
        body.classList.toggle('spclst-nav-transparent-active', transparentNow);
        body.classList.toggle('spclst-nav-in-hero-active', !!transparentContextActive && inTopSection);
        body.classList.toggle('spclst-nav-solid-active', !(!!transparentContextActive && inTopSection));
      }
      headerSectionRoots.forEach(function (headerSectionRoot) {
        headerSectionRoot.classList.remove('shopify-section-header-hidden');
        headerSectionRoot.classList.toggle('spclst-header-hidden', shouldHide);
        headerSectionRoot.classList.toggle('spclst-nav-wrapper-in-hero', !!transparentContextActive && inTopSection);
        headerSectionRoot.classList.toggle('spclst-nav-wrapper-solid', !(!!transparentContextActive && inTopSection));
      });

      /* Inline style lock so older CSS layers cannot override nav visibility/background state. */
      headerRoot.style.setProperty('background-color', transparentNow ? 'transparent' : 'var(--spclst-nav-bg)', 'important');
      headerRoot.style.setProperty('border-color', transparentNow ? 'transparent' : 'var(--spclst-nav-border)', 'important');
      headerRoot.style.setProperty('transform', shouldHide ? 'translate3d(0,-100%,0)' : 'translate3d(0,0,0)', 'important');
      headerRoot.style.setProperty('pointer-events', shouldHide ? 'none' : 'auto', 'important');
      document.documentElement.style.setProperty('--spclst-visible-nav-offset', (shouldHide ? 0 : navHeight) + 'px');

      var desktopViewport = window.matchMedia('(min-width: 992px)').matches;
      if (desktopNav) {
        desktopNav.style.setProperty('display', desktopViewport ? 'flex' : 'none', 'important');
        desktopNav.style.setProperty('visibility', desktopViewport ? 'visible' : 'hidden', 'important');
        desktopNav.style.setProperty('opacity', desktopViewport ? '1' : '0', 'important');
      }
      if (headerMobileNav) {
        headerMobileNav.style.setProperty('display', desktopViewport ? 'none' : 'flex', 'important');
        headerMobileNav.style.setProperty('visibility', desktopViewport ? 'hidden' : 'visible', 'important');
        headerMobileNav.style.setProperty('opacity', desktopViewport ? '0' : '1', 'important');
      }

      headerSectionRoots.forEach(function (headerSectionRoot) {
        if (!headerSectionRoot) return;
        headerSectionRoot.style.setProperty(
          'background-color',
          transparentNow ? 'transparent' : 'var(--spclst-nav-bg)',
          'important'
        );
        headerSectionRoot.style.setProperty(
          'border-color',
          transparentNow ? 'transparent' : 'var(--spclst-nav-border)',
          'important'
        );
      });

      lastScrollY = currentY;
    }

    function requestNavModeUpdate(event) {
      var fromScroll = !!(event && event.type === 'scroll');
      if (fromScroll) {
        var scrollTarget = getPrimaryScrollTarget();
        var eventTarget = event.target;
        if (scrollTarget === window) {
          if (eventTarget !== window && eventTarget !== document && eventTarget !== document.documentElement && eventTarget !== document.body) return;
        } else if (eventTarget !== scrollTarget) {
          return;
        }
      }
      if (!hasDynamicNavMode) return;
      if (scrollTicking) return;

      scrollTicking = true;
      window.requestAnimationFrame(function () {
        applyNavMode(fromScroll);
        scrollTicking = false;
      });
    }

    function syncMobileCartCount() {
      if (!mobileCartCounts.length || !cartBubble) return;
      var desktopCountEl = cartBubble.querySelector('.cartcount');
      if (!desktopCountEl) return;
      var countText = (desktopCountEl.textContent || '').trim();
      if (!countText) return;
      mobileCartCounts.forEach(function (counter) {
        counter.textContent = String(parseInt(countText, 10) || 0);
      });
    }

    function getCartDrawer() {
      return query('cart-drawer');
    }

    function openCartDrawer(event) {
      if (event) event.preventDefault();

      var opener = event && event.currentTarget ? event.currentTarget : cartBubble || null;

      function handleCartDrawerUnavailable() {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('[SPCLST cart] Cart drawer was not available; staying on the current page instead of opening /cart.');
        }
      }

      function openActiveCartDrawer(attempt) {
        var retryAttempt = attempt || 0;
        var activeCartDrawer = getCartDrawer() || cartDrawer;
        if (!activeCartDrawer || typeof activeCartDrawer.open !== 'function') {
          if (retryAttempt < 20) {
            window.setTimeout(function () {
              openActiveCartDrawer(retryAttempt + 1);
            }, 100);
          } else {
            handleCartDrawerUnavailable();
          }
          return;
        }

        cartDrawer = activeCartDrawer;
        closeDesktopSubmenus();
        if (typeof activeCartDrawer.openWithRefresh === 'function') {
          activeCartDrawer.openWithRefresh(opener);
        } else {
          activeCartDrawer.open(opener);
        }
        if (headerRoot) headerRoot.classList.remove('spclst-nav-hidden');
        syncMobileCartCount();
        queueFreeShippingSync();
      }

      if (
        window.customElements &&
        window.customElements.whenDefined &&
        !window.customElements.get('cart-drawer')
      ) {
        window.customElements.whenDefined('cart-drawer').then(function () {
          openActiveCartDrawer(0);
        }).catch(handleCartDrawerUnavailable);
        return;
      }

      openActiveCartDrawer(0);
    }

    function clearHoverCloseTimer() {
      if (!hoverCloseTimer) return;
      window.clearTimeout(hoverCloseTimer);
      hoverCloseTimer = null;
    }

    function isNavHidden() {
      return !!(headerRoot && headerRoot.classList.contains('spclst-nav-hidden'));
    }

    function scheduleDesktopSubmenuClose() {
      clearHoverCloseTimer();
      hoverCloseTimer = window.setTimeout(function () {
        if (!isDesktopNavViewport()) return;
        closeDesktopSubmenus();
      }, 140);
    }

    function syncBodyLock() {
      var shouldLock =
        (mobileNav && mobileNav.classList.contains('spclst-open')) ||
        (mobileSearch && mobileSearch.classList.contains('spclst-open'));
      body.classList.toggle('nobodyscroll', shouldLock);
      requestNavModeUpdate();
    }

    function setMobileBrandExpanded(section, expanded) {
      if (!section) return;
      section.classList.toggle('spclst-open', expanded);
      var toggle = query('[data-spclst-mobile-brand-toggle]', section);
      if (toggle) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function collapseMobileBrandSections() {
      mobileBrandSections.forEach(function (section) {
        setMobileBrandExpanded(section, false);
      });
    }

    function closeMobileNav() {
      if (!mobileNav) return;
      if (mobileNavCloseTimer) {
        window.clearTimeout(mobileNavCloseTimer);
        mobileNavCloseTimer = null;
      }
      if (mobileNav.classList.contains('spclst-open')) {
        mobileNav.classList.add('spclst-closing');
        mobileNavCloseTimer = window.setTimeout(function () {
          mobileNav.classList.remove('spclst-closing');
          mobileNavCloseTimer = null;
        }, 320);
      } else {
        mobileNav.classList.remove('spclst-closing');
      }
      mobileNav.classList.remove('spclst-open');
      collapseMobileBrandSections();
      syncBodyLock();
    }

    function openMobileNav() {
      if (!mobileNav) return;
      if (Date.now && Date.now() < mobileNavSuppressOpenUntil) return;
      if (mobileNavCloseTimer) {
        window.clearTimeout(mobileNavCloseTimer);
        mobileNavCloseTimer = null;
      }
      closeMobileSearch();
      collapseMobileBrandSections();
      mobileNav.classList.remove('spclst-closing');
      mobileNav.classList.add('spclst-open');
      syncBodyLock();
    }

    function handleMobileNavCloseEvent(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }
      mobileNavSuppressOpenUntil = (Date.now ? Date.now() : new Date().getTime()) + 450;
      closeMobileNav();
    }

    function closeMobileSearch() {
      if (!mobileSearch) return;
      mobileSearch.classList.remove('spclst-open');
      syncBodyLock();
    }

    function openMobileSearch() {
      if (!mobileSearch) return;
      closeMobileNav();
      mobileSearch.classList.add('spclst-open');
      syncBodyLock();
    }

    function closeDesktopSubmenus() {
      if (!submenuContainer) return;
      clearHoverCloseTimer();
      submenuContainer.classList.remove('spclst-open');
      desktopSubmenus.forEach(function (submenu) {
        submenu.classList.remove('spclst-active');
      });
      syncDesktopSubmenuTriggerState();
      if (headerRoot) headerRoot.classList.remove('spclst-nav-hover');
      requestNavModeUpdate();
    }

    function getDesktopSubmenuTriggerName(trigger) {
      if (trigger.hasAttribute('data-spclst-open-desktop-search')) return 'search';
      if (trigger.hasAttribute('data-spclst-open-desktop-brand')) return 'brand';
      return 'shop';
    }

    function syncDesktopSubmenuTriggerState(activeName) {
      desktopSubmenuTriggers.forEach(function (trigger) {
        var triggerName = getDesktopSubmenuTriggerName(trigger);
        trigger.setAttribute('aria-expanded', activeName === triggerName ? 'true' : 'false');
      });
    }

    function syncDesktopBrandPanelWidth() {
      if (!desktopBrandTrigger || !desktopBrandSubmenu) return;

      if (!isDesktopNavViewport()) {
        desktopBrandSubmenu.style.removeProperty('--spclst-brand-panel-width');
        return;
      }

      var brandTriggerRect = desktopBrandTrigger.getBoundingClientRect();
      var viewportWidth = Math.max(
        window.innerWidth || 0,
        document.documentElement ? document.documentElement.clientWidth : 0
      );
      var brandPanelLeftEdge = Math.max(0, brandTriggerRect.left - 48);
      var panelWidth = Math.min(
        viewportWidth,
        Math.max(0, viewportWidth - brandPanelLeftEdge)
      );

      if (!panelWidth) {
        desktopBrandSubmenu.style.removeProperty('--spclst-brand-panel-width');
        return;
      }

      desktopBrandSubmenu.style.setProperty(
        '--spclst-brand-panel-width',
        panelWidth.toFixed(2) + 'px'
      );
    }

    function openDesktopSubmenu(name) {
      if (!submenuContainer) return;
      clearHoverCloseTimer();

      var target = query('[data-spclst-submenu="' + name + '"]', submenuContainer);
      if (!target) return;

      if (name === 'brand') syncDesktopBrandPanelWidth();

      submenuContainer.classList.add('spclst-open');
      desktopSubmenus.forEach(function (submenu) {
        submenu.classList.remove('spclst-active');
      });
      target.classList.add('spclst-active');
      syncDesktopSubmenuTriggerState(name);
      if (headerRoot) {
        headerRoot.classList.remove('spclst-nav-hidden');
        headerRoot.classList.add('spclst-nav-hover');
      }
      requestNavModeUpdate();
    }

    function getActiveDesktopSubmenu() {
      if (!submenuContainer) return null;
      return query('[data-spclst-submenu].spclst-active', submenuContainer);
    }

    function pointIsInsideElement(event, element) {
      if (!event || !element || typeof element.getBoundingClientRect !== 'function') return false;
      var rect = element.getBoundingClientRect();
      return (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      );
    }

    function pointIsInsideDesktopNavArea(event) {
      if (!isDesktopNavViewport()) return false;
      var activeSubmenu = getActiveDesktopSubmenu();
      return (
        pointIsInsideElement(event, desktopNavRow) ||
        pointIsInsideElement(event, activeSubmenu)
      );
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function getPredictiveSearchUrl(term) {
      var baseUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
      return (
        baseUrl +
        separator +
        'q=' +
        encodeURIComponent(term) +
        '&section_id=predictive-search'
      );
    }

    function extractMenuSearchSuggestions(markup) {
      var template = document.createElement('template');
      template.innerHTML = markup;

      var suggestionSelectors = [
        '#predictive-search-results-queries-list a',
        '#predictive-search-results-products-list a',
        '#predictive-search-results-pages-list-desktop a',
        '#predictive-search-results-pages-list-mobile a',
      ];
      var suggestions = [];
      var seen = {};

      suggestionSelectors.forEach(function (selector) {
        queryAll(selector, template.content).forEach(function (link) {
          if (suggestions.length >= 5) return;
          var href = link.getAttribute('href');
          var heading = query('.predictive-search__item-heading', link);
          var title = ((heading || link).textContent || '').replace(/\s+/g, ' ').trim();
          if (!href || !title) return;

          var key = href + '|' + title.toLowerCase();
          if (seen[key]) return;
          seen[key] = true;
          suggestions.push({ href: href, title: title });
        });
      });

      return suggestions;
    }

    function renderMenuSearchSuggestions(results, suggestions) {
      if (!results) return;
      results.classList.toggle('is-empty', !suggestions.length);
      results.innerHTML = suggestions
        .map(function (suggestion) {
          return (
            '<a href="' +
            escapeHtml(suggestion.href) +
            '" class="searchsuggestion">' +
            escapeHtml(suggestion.title) +
            '</a>'
          );
        })
        .join('');
    }

    function initMenuSearchSuggestions() {
      queryAll('[data-spclst-menu-search-form]').forEach(function (form) {
        if (form.getAttribute('data-spclst-menu-search-initialized') === 'true') return;
        form.setAttribute('data-spclst-menu-search-initialized', 'true');

        var input = query('[data-spclst-menu-search-input]', form);
        var searchModal = form.closest('.search-modal');
        var suggestionsRoot = searchModal ? query('.contact-us-container.suggestions', searchModal) : null;
        var results = searchModal ? query('[data-spclst-menu-search-results]', searchModal) : null;
        if (!input || !suggestionsRoot || !results) return;

        var cache = {};
        var debounceTimer = null;
        var requestId = 0;

        function showDefaultSuggestions() {
          requestId += 1;
          suggestionsRoot.classList.remove('spclst-menu-search-has-query');
          results.removeAttribute('aria-busy');
          results.classList.remove('is-empty');
          results.innerHTML = '';
        }

        function showLiveSuggestions(term) {
          suggestionsRoot.classList.add('spclst-menu-search-has-query');
          results.classList.remove('is-empty');

          if (cache[term]) {
            results.removeAttribute('aria-busy');
            renderMenuSearchSuggestions(results, cache[term]);
            return;
          }

          var currentRequestId = requestId;
          results.setAttribute('aria-busy', 'true');

          fetch(getPredictiveSearchUrl(term), { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) throw new Error('Predictive search request failed');
              return response.text();
            })
            .then(function (markup) {
              if (currentRequestId !== requestId) return;
              var suggestions = extractMenuSearchSuggestions(markup);
              cache[term] = suggestions;
              results.removeAttribute('aria-busy');
              renderMenuSearchSuggestions(results, suggestions);
            })
            .catch(function () {
              if (currentRequestId !== requestId) return;
              results.removeAttribute('aria-busy');
              renderMenuSearchSuggestions(results, []);
            });
        }

        function handleSearchInput() {
          var term = (input.value || '').trim();
          requestId += 1;

          if (!term) {
            showDefaultSuggestions();
            return;
          }

          window.clearTimeout(debounceTimer);
          debounceTimer = window.setTimeout(function () {
            showLiveSuggestions(term);
          }, 160);
        }

        input.addEventListener('input', handleSearchInput);
        input.addEventListener('search', handleSearchInput);
        handleSearchInput();
      });
    }

    initMenuSearchSuggestions();

    on('[data-spclst-open-nav]', 'click', function (event) {
      event.preventDefault();
      if (Date.now && Date.now() < mobileNavSuppressOpenUntil) return;
      openMobileNav();
    });

    on('[data-spclst-close-nav]', 'click', function (event) {
      handleMobileNavCloseEvent(event);
    });

    on('[data-spclst-open-search]', 'click', function (event) {
      event.preventDefault();
      openMobileSearch();
    });

    on('[data-spclst-close-search]', 'click', function (event) {
      event.preventDefault();
      closeMobileSearch();
    });

    on('[data-spclst-open-desktop-shop]', 'click', function (event) {
      if (event.currentTarget.matches('a[href]')) return;
      event.preventDefault();
      clearHoverCloseTimer();
      var shopSubmenu = query('[data-spclst-submenu="shop"]', submenuContainer || document);
      if (shopSubmenu && shopSubmenu.classList.contains('spclst-active')) {
        closeDesktopSubmenus();
      } else {
        openDesktopSubmenu('shop');
      }
    });

    on('[data-spclst-open-desktop-search]', 'click', function (event) {
      event.preventDefault();
      clearHoverCloseTimer();
      var searchSubmenu = query('[data-spclst-submenu="search"]', submenuContainer || document);
      if (searchSubmenu && searchSubmenu.classList.contains('spclst-active')) {
        closeDesktopSubmenus();
      } else {
        openDesktopSubmenu('search');
      }
    });

    on('[data-spclst-open-desktop-brand]', 'click', function (event) {
      if (event.currentTarget.matches('a[href]')) return;
      event.preventDefault();
      clearHoverCloseTimer();
      var brandSubmenu = query('[data-spclst-submenu="brand"]', submenuContainer || document);
      if (brandSubmenu && brandSubmenu.classList.contains('spclst-active')) {
        closeDesktopSubmenus();
      } else {
        openDesktopSubmenu('brand');
      }
    });

    desktopSubmenuTriggers.forEach(function (trigger) {
      if (
        trigger.hasAttribute('data-spclst-open-desktop-shop') ||
        trigger.hasAttribute('data-spclst-open-desktop-brand')
      ) {
        trigger.addEventListener('pointerenter', function () {
          if (!isDesktopNavViewport() || isNavHidden()) return;
          openDesktopSubmenu(getDesktopSubmenuTriggerName(trigger));
        });
      }

      trigger.addEventListener('keydown', function (event) {
        if (trigger.matches('a[href]')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        trigger.click();
      });
    });

    if (desktopNav) {
      desktopNav.addEventListener('mouseleave', function (event) {
        if (!isDesktopNavViewport()) return;
        var nextTarget = event && event.relatedTarget;
        if (nextTarget && submenuContainer && submenuContainer.contains(nextTarget)) return;
        if (!submenuContainer || !submenuContainer.classList.contains('spclst-open')) {
          if (headerRoot) headerRoot.classList.remove('spclst-nav-hover');
        }
      });
    }

    queryAll('[data-spclst-mobile-brand-toggle]').forEach(function (toggle) {
      var section = toggle.closest('.mobilemenusection');
      setMobileBrandExpanded(section, false);

      toggle.addEventListener('click', function () {
        var shouldExpand = !section.classList.contains('spclst-open');
        setMobileBrandExpanded(section, shouldExpand);
      });

      toggle.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        var shouldExpand = !section.classList.contains('spclst-open');
        setMobileBrandExpanded(section, shouldExpand);
      });
    });

    if (submenuContainer) {
      submenuContainer.addEventListener('pointerenter', function (event) {
        if (!isDesktopNavViewport()) return;
        if (isNavHidden()) return;
        if (!pointIsInsideElement(event, getActiveDesktopSubmenu())) return;
        if (headerRoot) headerRoot.classList.add('spclst-nav-hover');
        clearHoverCloseTimer();
      });
      submenuContainer.addEventListener('pointerleave', function (event) {
        if (!isDesktopNavViewport()) return;
        var nextTarget = event && event.relatedTarget;
        if (nextTarget && desktopNav && desktopNav.contains(nextTarget)) return;
        scheduleDesktopSubmenuClose();
      });
    }

    document.addEventListener(
      'pointermove',
      function (event) {
        if (!submenuContainer || !submenuContainer.classList.contains('spclst-open')) return;
        if (pointIsInsideDesktopNavArea(event)) {
          clearHoverCloseTimer();
          return;
        }
        scheduleDesktopSubmenuClose();
      },
      { passive: true }
    );

    on('[data-spclst-open-cart-drawer]:not(#cart-icon-bubble)', 'click', openCartDrawer);

    if (cartBubble && window.MutationObserver) {
      var cartBubbleObserver = new MutationObserver(syncMobileCartCount);
      cartBubbleObserver.observe(cartBubble, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    function parseMoneyToCents(rawValue) {
      var value = String(rawValue || '').trim();
      if (!value) return 0;

      var normalized = value.replace(/\s/g, '');
      var cleaned = normalized.replace(/[^0-9,.\-]/g, '');
      if (!cleaned) return 0;

      var lastComma = cleaned.lastIndexOf(',');
      var lastDot = cleaned.lastIndexOf('.');
      var decimalSeparator = '';

      if (lastDot > lastComma) {
        decimalSeparator = '.';
      } else if (lastComma > lastDot) {
        decimalSeparator = ',';
      }

      var numberString = cleaned;
      if (decimalSeparator === '.') {
        numberString = numberString.replace(/,/g, '');
      } else if (decimalSeparator === ',') {
        numberString = numberString.replace(/\./g, '').replace(',', '.');
      } else {
        numberString = numberString.replace(/[,.]/g, '');
      }

      var amount = parseFloat(numberString);
      if (isNaN(amount)) return 0;
      return Math.max(0, Math.round(amount * 100));
    }

    function formatCentsAsDisplayAmount(cents) {
      var normalizedCents = Math.max(0, Math.round(Number(cents) || 0));
      return (normalizedCents / 100).toFixed(2);
    }

    function updateFreeShippingMessage() {
      var totalEl = query('[data-spclst-cart-total]');
      var remainingWrap = query('[data-spclst-free-shipping-remaining]');
      var qualifiedWrap = query('[data-spclst-free-shipping-qualified]');
      var amountEl = query('[data-spclst-free-shipping-amount]');
      if (!totalEl || !remainingWrap || !qualifiedWrap || !amountEl) return;

      var totalCents = parseMoneyToCents(totalEl.textContent);
      var remainingCents = Math.max(0, freeShippingThresholdCents - totalCents);
      var qualified = totalCents >= freeShippingThresholdCents;

      amountEl.textContent = formatCentsAsDisplayAmount(remainingCents);
      remainingWrap.hidden = qualified;
      qualifiedWrap.hidden = !qualified;
    }

    function queueFreeShippingSync() {
      if (freeShippingSyncQueued) return;
      freeShippingSyncQueued = true;
      window.requestAnimationFrame(function () {
        freeShippingSyncQueued = false;
        updateFreeShippingMessage();
      });
    }

    if (window.MutationObserver && cartDrawer) {
      var cartDrawerObserver = new MutationObserver(function () {
        queueFreeShippingSync();
      });
      cartDrawerObserver.observe(cartDrawer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    document.addEventListener('cart:refresh', queueFreeShippingSync);
    document.addEventListener('cart:updated', queueFreeShippingSync);
    syncMobileCartCount();
    queueFreeShippingSync();

    document.addEventListener('click', function (event) {
      if (!submenuContainer || !headerRoot) return;

      var clickedInHeader = headerRoot.contains(event.target);
      var clickedInSubmenu = submenuContainer.contains(event.target);

      if (!clickedInHeader && !clickedInSubmenu) {
        closeDesktopSubmenus();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeDesktopSubmenus();
      closeMobileNav();
      closeMobileSearch();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth < 992) {
        closeDesktopSubmenus();
      } else {
        closeMobileNav();
        closeMobileSearch();
      }
      resolveTopSection();
      resolveHeaderSectionRoots();
      refreshTopSectionBounds();
      syncDesktopBrandPanelWidth();
      applyNavMode();
    });

    resolveTopSection();
    refreshTopSectionBounds();
    syncDesktopBrandPanelWidth();
    lastScrollY = getScrollY();
    applyNavMode();
    window.addEventListener('scroll', requestNavModeUpdate, { passive: true });
    document.addEventListener('scroll', requestNavModeUpdate, { passive: true, capture: true });
    if (mainContentRoot) {
      mainContentRoot.addEventListener('scroll', requestNavModeUpdate, { passive: true });
    }
    window.addEventListener('load', function () {
      resolveTopSection();
      resolveHeaderSectionRoots();
      refreshTopSectionBounds();
      applyNavMode();
    });

    // Shopify editor re-renders sections in-place; refresh nav hero bounds each time.
    var refreshDynamicNavState = function () {
      homeHero = query('.spclst-hero');
      resolveHeaderSectionRoots();
      resolveTopSection();
      refreshTopSectionBounds();
      applyNavMode();
    };

    document.addEventListener('shopify:section:load', refreshDynamicNavState);
    document.addEventListener('shopify:section:unload', refreshDynamicNavState);
    document.addEventListener('shopify:section:select', refreshDynamicNavState);
    document.addEventListener('shopify:section:deselect', refreshDynamicNavState);
    document.addEventListener('shopify:block:select', refreshDynamicNavState);
    document.addEventListener('shopify:block:deselect', refreshDynamicNavState);

    if (mainContentRoot && window.MutationObserver) {
      var navTopObserver = new MutationObserver(function () {
        refreshDynamicNavState();
      });
      navTopObserver.observe(mainContentRoot, { childList: true, subtree: true });
    }

    if (headerSectionRoots.length && window.MutationObserver) {
      headerSectionRoots.forEach(function (headerSectionRoot) {
        var headerClassObserver = new MutationObserver(function () {
          if (!headerSectionRoot) return;
          if (headerSectionRoot.classList.contains('shopify-section-header-hidden')) {
            headerSectionRoot.classList.remove('shopify-section-header-hidden');
          }
        });
        headerClassObserver.observe(headerSectionRoot, { attributes: true, attributeFilter: ['class'] });
      });
    }

  };
})();
